import { useRouter } from 'next/router';
import { Body } from '@Backlot-Cars/archie';

const SignupResumeMessage = ({ resumeStep, backButtonClicked }) => {
	const { query } = useRouter();
	const currentStep = parseInt(query?.step);

	if (currentStep !== resumeStep || backButtonClicked) return null;

	return (
		<Body color="alert">
			A sign-up has already been started with that email address, please proceed forward with the needed
			information. If you do not remember completing this, please click the Back button below.
		</Body>
	);
};

export default SignupResumeMessage;
